import { Component } from '@angular/core';
import { environment } from './../environments/environment'
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { filter } from 'rxjs/operators';
import { Router, NavigationEnd } from '@angular/router'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'SitioPrivadoXKM';
  trackingCode = environment.gtmId;

  constructor(
    private gtmService: GoogleTagManagerService,
    private router: Router
  ){
    const navEndEvent$ = router.events.pipe(
      filter(e => e instanceof NavigationEnd)
    );
    navEndEvent$.subscribe((e: NavigationEnd) => {
      const gtmTag = {
        event: 'PageView',
        page_path: e.urlAfterRedirects
      };

      this.gtmService.pushTag(gtmTag);
    });
  }

  ngOnInit() {
    this.gtmService.addGtmToDom();
  }
}


